import React from "react";
import { ManageTradeLayout } from "../../../components";
import { Button, Image } from "react-bootstrap";
import {
  manageTradeFormNames,
  formFields,
  getPathWithParam,
  MANAGE_TRADE_ROUTES,
} from "../../../utils";
import { SearchView } from "../SearchView";
import { CardsLayout } from "../CardsLayout";
import ExcelImage from "../../../styles/exportimg.PNG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
const columns = [
  {
    id: "transactionID",
    label: "Transaction ID",
    style: { paddingLeft: "20px", fontSize: "14px", width: "25%" },
    className: "grey-text font-weight-700",
    styleName: "trade-flex-column",
  },
  {
    id: "ssn",
    label: "SSN",
    style: { fontSize: "14px", width: "20%", paddingLeft: "10px" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-20",
  },
  {
    id: "planId",
    label: "Plan ID",
    style: { fontSize: "14px", width: "15%", paddingLeft: "10px" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-15",
  },
  {
    id: "transactionType",
    label: "Transaction type",
    style: { fontSize: "14px", width: "15%", paddingLeft: "5px" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-15",
  },
  {
    id: "date",
    label: "Date",
    style: { fontSize: "14px", width: "15%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-15",
  },
  {
    id: "action",
    label: "Action",
    style: {
      fontSize: "14px",
      width: "10%",
    },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-10 justify-content-center",
  },
];

const TransactionViewContainer = (props) => {
  const TableContent = {
    transactionID: (a, e) => {
      console.log(a, e, "args");
      return (
        <div className={a.styleName}>
          <div className="transaction-card-top-row">{e}</div>
          <div className="transaction-card-bottom-rom">
            <div className="transaction-status">
              <FontAwesomeIcon icon={faCheckCircle} />
              <div>{"completed"}</div>
            </div>
          </div>
        </div>
      );
    },
    ssn: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    planId: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    transactionType: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    date: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    action: (a, e) => (
      <Button className={a.styleName} variant="secondary">
        Cancel Trade
      </Button>
    ),
    default: (a, e) => null,
  };
  const onSubmit = () => {};
  return (
    <CardsLayout>
      <div className="column-filters">
        {columns.map((_) => (
          <div className={_.className} style={{ ..._.style }}>
            {" "}
            {_.label}
          </div>
        ))}
      </div>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((e, i) => {
        return (
          <Link
            className="generic-table-component trade-transaction-card"
            to={getPathWithParam({
              path: MANAGE_TRADE_ROUTES.TRANSACTION_VIEW_DETAILS,
            })}
          >
            {columns.map((a, b) => {
              console.log(a, "regs");
              // const args = {...a,...e}
              return TableContent[a.id](a, e);
            })}
          </Link>
        );
      })}
    </CardsLayout>
  );
};

export default TransactionViewContainer;
